import { render, staticRenderFns } from "./QAhome.vue?vue&type=template&id=47b0689a&scoped=true&"
import script from "./QAhome.vue?vue&type=script&lang=js&"
export * from "./QAhome.vue?vue&type=script&lang=js&"
import style0 from "./QAhome.vue?vue&type=style&index=0&id=47b0689a&scoped=true&lang=css&"
import style1 from "./QAhome.vue?vue&type=style&index=1&id=47b0689a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0689a",
  null
  
)

export default component.exports